/**
 * Map product name -> array of real product photos inside brand folders.
 * The first image is used on hover. All images are used in detail/modal galleries.
 * If a product is not listed here, it falls back to the default placeholder.
 */
const brandPath = (brand, slug, n, ext) => encodeURI(`/image/Perfume brands/${brand}/${slug}-${n}.${ext}`);
const brandImages = (brand, slug, count, ext) =>
  Array.from({ length: count }, (_, i) => brandPath(brand, slug, i + 1, ext));
const single = (brand, slug, ext) => brandImages(brand, slug, 1, ext);

export const PRODUCT_IMAGES = {
  // Men's Section
  'Bleu de Chanel': brandImages('Chanel', 'bleu-de-chanel', 3, 'jpg'),
  'Boss Bottled': brandImages('Hugo Boss', 'boss-bottled', 4, 'jpg'),
  Aventus: brandImages('Creed', 'aventus', 2, 'webp'),
  Fahrenheit: brandImages('Dior', 'fahrenheit', 3, 'jpg'),
  'Lacoste Black': brandImages('Lacoste', 'lacoste-black', 1, 'webp'),
  'Acqua Di Gio': brandImages('Armani', 'acqua-di-gio', 1, 'jpg'),
  'The One': brandImages('Dolce & Gabbana', 'the-one', 1, 'jpg'),
  Legend: brandImages('Montblanc', 'legend', 1, 'jpg'),
  'Stronger With You': brandImages('Armani', 'stronger-with-you', 4, 'jpg'),
  'Boss The Scent': brandImages('Hugo Boss', 'boss-the-scent', 3, 'jpg'),
  "Black XS L'Exces": brandImages('Paco Rabanne', 'black-xs-lexces', 3, 'jpg'),
  Eros: brandImages('Versace', 'eros', 1, 'jpg'),
  'Ultra Male': brandImages('Jean Paul Gaultier', 'ultra-male', 2, 'jpg'),
  'Lacoste White': brandImages('Lacoste', 'lacoste-white', 2, 'jpg'),
  Voyage: brandImages('Nautica', 'voyage', 2, 'jpg'),
  'Dunhill Desire': brandImages('Dunhill', 'dunhill-desire', 2, 'jpg'),
  Y: brandImages('Yves Saint Laurent (YSL)', 'y', 1, 'jpg'),
  'One Million Elixir': brandImages('Paco Rabanne', 'one-million-elixir', 1, 'jpg'),
  'One Million Lucky': brandImages('Paco Rabanne', 'one-million-lucky', 1, 'webp'),
  Sauvage: brandImages('Dior', 'sauvage', 1, 'jpg'),
  'Azzaro Chrome': brandImages('Azzaro', 'azzaro-chrome', 1, 'webp'),
  'Le Male Elixir': brandImages('Jean Paul Gaultier', 'le-male-elixir', 1, 'webp'),
  'The Most Wanted': brandImages('Azzaro', 'the-most-wanted', 1, 'jpg'),
  '212 Men NYC': brandImages('Carolina Herrera', '212-men-nyc', 1, 'webp'),
  'Marbelt Man': brandImages('Lithioo', 'marbelt-man', 1, 'jpg'),
  'Silver Mountain Water': brandImages('Creed', 'silver-mountain-water', 1, 'jpg'),
  Phantom: brandImages('Paco Rabanne', 'phantom', 1, 'jpg'),
  Invictus: brandImages('Paco Rabanne', 'invictus', 1, 'jpg'),
  K: brandImages('Dolce & Gabbana', 'k', 1, 'jpg'),
  'Silver Scent': brandImages('Jacques Bogart', 'silver-scent', 2, 'jpg'),

  // Women's Section
  'Yara Candy': single('Lattafa', 'yara-candy', 'jpg'),
  'Moon Sparkle': single('Escada', 'moon-sparkle', 'webp'),
  'Idôle': single('Lancôme', 'idole', 'webp'),
  'Vanilla 28': single('Kayali', 'vanilla-28', 'jpg'),
  'Good Girl': single('Carolina Herrera', 'good-girl', 'jpg'),
  'Escada Collection': single('Escada', 'escada-collection', 'jpg'),
  'La Nuit Trésor': single('Lancôme', 'la-nuit-tresor', 'jpg'),
  Libre: single('Yves Saint Laurent (YSL)', 'libre', 'jpg'),
  Scandal: single('Jean Paul Gaultier', 'scandal', 'jpg'),
  'Roberto Cavalli': single('Roberto Cavalli', 'roberto-cavalli', 'jpg'),
  'Modern Princess': single('Lanvin', 'modern-princess', 'jpg'),
  'Bare Vanilla': single("Victoria's Secret", 'bare-vanilla', 'webp'),
  "Because It's You": single('Armani', 'because-its-you', 'png'),
  Bombshell: single("Victoria's Secret", 'bombshell', 'webp'),
  'Agua Del Sol': single('Escada', 'agua-del-sol', 'jpg'),
  'Black Opium': single('Yves Saint Laurent (YSL)', 'black-opium', 'jpg'),
  'Vanilla Candy Rock Sugar': single('Kayali', 'vanilla-candy-rock-sugar', 'webp'),
  'Sí Passione': single('Armani', 'si-passione', 'jpg'),
  'Midnight Fantasy': single('Britney Spears', 'midnight-fantasy', 'jpg'),
  'Private Show': single('Britney Spears', 'private-show', 'webp'),
  Goddess: single('Burberry', 'goddess', 'jpg'),
  'Black XS Potion': single('Paco Rabanne', 'black-xs-potion', 'webp'),
  'Roses Vanille': single('Mancera', 'roses-vanille', 'jpg'),
  "J'adore": single('Dior', 'jadore', 'jpg'),
  'La Vie Est Belle': single('Lancôme', 'la-vie-est-belle', 'jpg'),
  Olympea: single('Paco Rabanne', 'olympea', 'jpg'),
  Fantasy: single('Britney Spears', 'fantasy', 'webp'),
  'Burberry Her': single('Burberry', 'burberry-her', 'jpg'),
  'Very Sexy Now': single("Victoria's Secret", 'very-sexy-now', 'jpg'),
  'Love Is Heavenly': single("Victoria's Secret", 'love-is-heavenly', 'webp'),
  'Wanted Girl': single('Azzaro', 'wanted-girl', 'jpg'),
  'Paris Hilton': single('Paris Hilton', 'paris-hilton', 'jpg'),
  'Miss Dior Chérie': single('Dior', 'miss-dior-cherie', 'jpg'),
  'Katy Perry': single('Katy Perry', 'katy-perry', 'jpg'),
  Icon: single('Rasasi', 'icon', 'jpg'),
  'Voce Viva': single('Valentino', 'voce-viva', 'jpg'),

  // Oriental (Special) Section
  Xerjoff: single('Xerjoff', 'xerjoff', 'webp'),
  Maghnawi: single('Arabian Oud', 'maghnawi', 'webp'),
  'She Oud': single('Lithioo', 'she-oud', 'jpg'),
  'Mukhalaat Maa El Thahab': single('Lithioo', 'mukhalaat-maa-el-thahab', 'jpg'),
  'Amber Desire': single('Lithioo', 'amber-desire', 'jpg'),
  'Musk Al Tahara': single('Lithioo', 'musk-al-tahara', 'jpg'),
  'Musk Cherry': single('Lithioo', 'musk-cherry', 'jpg'),
  'Black Afgano': single('Nasomatto', 'black-afgano', 'jpg'),
  'Al Fares Al Asmar': single('Lithioo', 'al-fares-al-asmar', 'jpg'),
  'Silk Musk': single('Lithioo', 'silk-musk', 'jpg'),
  Kalemat: single('Arabian Oud', 'kalemat', 'jpg'),
  'Black Orchid': single('Tom Ford', 'black-orchid', 'webp'),
  'Strawberry Musk': single('Lithioo', 'strawberry-musk', 'jpg'),
  'Al Ghareeb': single('Lithioo', 'al-ghareeb', 'jpg'),
  'Bianco Latte': single('Lithioo', 'bianco-latte', 'webp'),
  Kalan: single('Parfums de Marly', 'kalan', 'jpg'),
  Layton: single('Parfums de Marly', 'layton', 'webp'),
  'Musk Al Tahara Pomegranate': single('Lithioo', 'musk-al-tahara-pomegranate', 'webp'),
  Tuxedo: single('Yves Saint Laurent (YSL)', 'tuxedo', 'webp'),
  'Sweet Musk': single('Lithioo', 'sweet-musk', 'webp'),
  'Hersh Laheeb': single('Lithioo', 'hersh-laheeb', 'webp'),
  Khamrah: brandImages('Lattafa', 'khamrah', 2, 'jpg'),
  Percival: single('Parfums de Marly', 'percival', 'webp'),
  'Deja Vu': single('Gissah', 'deja-vu', 'webp'),
  'Stronger With You Amber': single('Armani', 'stronger-with-you-amber', 'jpg'),
  'Alf Leila Wa Leila (1001 Nights)': single('Lithioo', 'alf-leila-wa-leila', 'webp'),
  Hacivat: single('Nishane', 'hacivat', 'jpg'),
  'Al Hajar Al Aswad (The Black Stone)': single('Lithioo', 'al-hajar-al-aswad', 'jpg'),
  'Imperial Valley': single('Gissah', 'imperial-valley', 'jpg'),
  'Erba Pura': single('Sospiro', 'erba-pura', 'avif'),
  'Amber Malaki': single('Chopard', 'amber-malaki', 'webp'),
  Daarej: single('Rasasi', 'daarej', 'webp'),
  'Historic Sahara': single('Afnan', 'historic-sahara', 'jpg'),
  Megamare: single('Orto Parisi', 'megamare', 'jpg'),
  'Pomegranate Musk': single('Lithioo', 'pomegranate-musk', 'jpg'),
  'Sir Al Khulood': single('Lattafa', 'sir-al-khulood', 'webp'),
  Shaghaf: single('Swiss Arabian', 'shaghaf', 'webp'),
  'Baccarat Rouge 540': single('Maison Francis Kurkdjian', 'baccarat-rouge-540', 'jpg'),
  'Gobar El Thahab': single('Sahara', 'gobar-el-thahab', 'jpg'),
  'Arabians Tonka': single('Montale', 'arabians-tonka', 'webp'),
  'Ana Abiyedh': single('Lattafa', 'ana-abiyedh', 'jpg'),
  Manifesto: single('Yves Saint Laurent (YSL)', 'manifesto', 'jpg'),
};

export const getProductImages = (name) => PRODUCT_IMAGES[name] || null;
